//Iphone 5
export const SMALL_MOBILE = '320px';
export const MOBILE = '767px';
export const BELOW_MEDIUM_DESKTOP = '991px';
export const BELOW_LARGE_DESKTOP = '1200px';
